var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.key,staticClass:"body flex-column",attrs:{"height":"100%"}},[_c('VbitStatusBanner',{attrs:{"module":"bklr"}}),_c('AppToolbar'),_c('Bkrl',{attrs:{"lang":_vm.lang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }